import React from 'react'
import styles from './KeyboardShortcuts.module.scss'
import lookLeft from '../../../assets/svg/KeyboardShortcuts/LookLeft.svg'
import lookNorth from '../../../assets/svg/KeyboardShortcuts/LookNorth.svg'
import lookRight from '../../../assets/svg/KeyboardShortcuts/LookRight.svg'
import moveBack from '../../../assets/svg/KeyboardShortcuts/MoveBack.svg'
import moveForward from '../../../assets/svg/KeyboardShortcuts/MoveForward.svg'
import moveLeft from '../../../assets/svg/KeyboardShortcuts/MoveLeft.svg'
import moveRight from '../../../assets/svg/KeyboardShortcuts/MoveRight.svg'
import zoomIn3 from '../../../assets/svg/KeyboardShortcuts/ZoomIn3.svg'
import zoomOut3 from '../../../assets/svg/KeyboardShortcuts/ZoomOut3.svg'

function KeyboardShortcutsContent2D() {
	return (
		<div className={styles.keyboardShortcuts}>
			<div className={styles.section}>
				<div className={styles.sectionTitle}>Navigating in 2D</div>

				<div className={styles.shortcutsSection}>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Look Around</span>
						<span className={styles.shortcut}>Left Click + Drag</span>
					</div>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Rotate</span>
						<span className={styles.shortcut}>Right Click + Drag</span>
					</div>
				</div>
				<div className={styles.shortcutsSection}>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Zoom In</span>
						<span className={styles.shortcut}>
							<img src={zoomIn3} />
						</span>
					</div>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Zoom Out</span>
						<span className={styles.shortcut}>
							<img src={zoomOut3} />
						</span>
					</div>
				</div>
				<div className={styles.shortcutsSection}>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Move Forward</span>
						<span className={styles.shortcut}>
							<img src={moveForward} />
						</span>
					</div>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Move Back</span>
						<span className={styles.shortcut}>
							<img src={moveBack} />
						</span>
					</div>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Move Left</span>
						<span className={styles.shortcut}>
							<img src={moveLeft} />
						</span>
					</div>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Move Right</span>
						<span className={styles.shortcut}>
							<img src={moveRight} />
						</span>
					</div>
				</div>
				<div className={styles.shortcutsSection}>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Look North</span>
						<span className={styles.shortcut}>
							<img src={lookNorth} />
						</span>
					</div>
				</div>
				<div className={styles.shortcutsSection}>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Rotate Left</span>
						<span className={styles.shortcut}>
							<img src={lookLeft} />
						</span>
					</div>
					<div className={styles.shortcutItem}>
						<span className={styles.name}>Rotate Right</span>
						<span className={styles.shortcut}>
							<img src={lookRight} />
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}

export default KeyboardShortcutsContent2D
